webpackJsonp([1,2],{

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(355)

var Component = __webpack_require__(47)(
  /* script */
  __webpack_require__(160),
  /* template */
  __webpack_require__(377),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 103:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_juicytag_jpg__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_juicytag_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_juicytag_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_dronetracker_jpg__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_dronetracker_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_dronetracker_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_magenta_fm_jpg__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_magenta_fm_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_magenta_fm_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_inspire_jpg__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_inspire_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_inspire_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_lastdrummer_jpg__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_lastdrummer_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_lastdrummer_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_cjmobiledj_jpg__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_cjmobiledj_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_cjmobiledj_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_chuckarnotes_png__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_chuckarnotes_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_chuckarnotes_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_flexbox_jpg__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_flexbox_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_flexbox_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_bcw_jpg__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_bcw_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_bcw_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_cheatsheets_jpg__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_cheatsheets_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_cheatsheets_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_ethos_png__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_ethos_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_ethos_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_shadowban_jpg__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_shadowban_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_shadowban_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_cookiecutter_jpg__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_cookiecutter_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_cookiecutter_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_moderndj_jpg__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_moderndj_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_moderndj_jpg__);


















var count = -1;
function id() {
  count = count + 1;
  return count;
}

var Project = function Project(_ref) {
  var title = _ref.title,
      description = _ref.description,
      image = _ref.image,
      link = _ref.link,
      weight = _ref.weight,
      stack = _ref.stack;

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Project);

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this, { title: title, description: description, image: image, link: link, weight: weight, stack: stack });
  this.index = id();
};

var pug = 'Pug',
    sass = 'Sass',
    babel = 'Babel',
    js = 'JavaScript',
    es = 'ES2015',
    webpack = 'Webpack',
    vue = 'Vue.js',
    vuex = 'Vuex',
    firebase = 'Firebase',
    rails = 'Ruby on Rails',
    material = 'Material Design',
    haml = 'HAML',
    postgres = 'PostgreSQL',
    gulp = 'Gulp',
    browserify = 'Browserify',
    unity = 'Unity',
    unityCollab = 'Unity Collaborate (BETA)',
    cSharp = 'C#',
    heroku = 'heroku',
    jQuery = 'jQuery',
    reactNative = 'React Native',
    react = 'React',
    imageMagick = 'ImageMagick',
    vanillajs = 'Vanilla JS',
    html = 'HTML',
    css = 'CSS',
    node = 'Node.js',
    ruby = 'Ruby',
    git = 'Git',
    github = 'Github',
    angular = 'Angular 1.5.x',
    flow = 'FlowType',
    mocha = 'Mocha',
    chai = 'Chai',
    express = 'Express.js',
    restAPI = 'REST API',
    design = 'Design',
    seo = 'SEO',
    advancedJS = [js, babel, es, node],
    toolkit = {
  advancedJS: advancedJS,
  vue: [vue, webpack, pug, sass].concat(advancedJS, [git]),
  unity: [unity, unityCollab, cSharp, git],
  groundUp: [js, vanillajs, git]
};
var projects = [new Project({
  title: 'CodeWorks Backpack',
  description: 'A classroom dashboard for CodeWorks students. (in beta)',
  image: __WEBPACK_IMPORTED_MODULE_11__assets_bcw_jpg___default.a,
  stack: [firebase, vuex, pug].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(toolkit.vue))

}), new Project({
  title: 'Boise CodeWorks Cheatsheets',
  description: 'A resource sharing platform for students learning to code',
  image: __WEBPACK_IMPORTED_MODULE_12__assets_cheatsheets_jpg___default.a,
  link: 'https://bcw-cheatsheets.herokuapp.com/',
  stack: [rails, material, sass, haml, postgres, jQuery, git]
}), new Project({
  title: 'FlexBox Playground',
  description: 'The easiest way to try out css flexbox',
  image: __WEBPACK_IMPORTED_MODULE_10__assets_flexbox_jpg___default.a,
  link: 'https://mccallofthewild.github.io/flexbox/',
  weight: 2,
  stack: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(toolkit.vue))
}), new Project({
  title: 'Ethos',
  description: 'Intuitive state management',
  image: __WEBPACK_IMPORTED_MODULE_13__assets_ethos_png___default.a,
  link: 'https://github.com/mccallofthewild/ethos',
  weight: 1,
  stack: [mocha, chai, react, git, github, webpack, flow].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(toolkit.advancedJS))
}), new Project({
  title: 'The Last Drummer',
  description: 'An immersive VR game combining music and an emoji invasion',
  image: __WEBPACK_IMPORTED_MODULE_7__assets_lastdrummer_jpg___default.a,
  weight: 3,
  stack: [cSharp, unity, unityCollab]
}), new Project({
  title: 'Juicy Tag',
  description: 'All your social media. One Link.',
  image: __WEBPACK_IMPORTED_MODULE_3__assets_juicytag_jpg___default.a,
  link: 'http://www.juicytag.com/',
  weight: 2,
  stack: [rails, js, sass, heroku, postgres, git]
}), new Project({
  title: 'Drone Tracker',
  description: 'Data visualization of drone strikes in the Middle East using DroneStream API',
  image: __WEBPACK_IMPORTED_MODULE_4__assets_dronetracker_jpg___default.a,
  link: 'http://mwolfhoffman.github.io/drone-tracker/#/home',
  weight: 2,
  stack: [angular, gulp, browserify, sass].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(toolkit.advancedJS), [git])
}), new Project({
  title: 'Magenta.fm',
  description: 'A localStorage-based music app with ground-up authentication. Utilizes iTunes API',
  image: __WEBPACK_IMPORTED_MODULE_5__assets_magenta_fm_jpg___default.a,
  link: 'https://magenta-fm.herokuapp.com/',
  weight: 3,
  stack: [jQuery, git]
}), new Project({
  title: 'Inspire',
  description: 'A welcoming web app, ported to React Native. Utilizes OpenWeatherMap API.',
  image: __WEBPACK_IMPORTED_MODULE_6__assets_inspire_jpg___default.a,
  weight: 4,
  link: 'https://mccallofthewild.github.io/inspire/',
  stack: [jQuery, reactNative].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(toolkit.advancedJS), [git])
}), new Project({
  title: 'CJ\'s Mobile DJ',
  description: 'Design, Blog, SEO and Copywriting for local DJ\'s website, sparking a 300% increase in leads',
  image: __WEBPACK_IMPORTED_MODULE_8__assets_cjmobiledj_jpg___default.a,
  link: 'http://www.cjyourdj.com/',
  weight: 4,
  stack: [rails, postgres, sass, angular, heroku, design, seo, git]
}), new Project({
  title: 'Chuckar Notes',
  description: 'A note sharing platform, made exclusively for TVCC students.',
  image: __WEBPACK_IMPORTED_MODULE_9__assets_chuckarnotes_png___default.a,
  link: 'http://tvccnoteapp.herokuapp.com/',
  weight: 3,
  stack: [rails, jQuery, heroku, postgres, imageMagick, git]
}), new Project({
  title: 'Instagram Shadowban Test',
  description: 'A bot that tests if Instagram is hiding your content',
  image: __WEBPACK_IMPORTED_MODULE_14__assets_shadowban_jpg___default.a,
  link: 'https://instagramshadowbantest.herokuapp.com/',
  weight: 2,
  stack: [restAPI, express].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(toolkit.vue), [vuex, git])
}), new Project({
  title: 'The Cookie Cutter',
  description: 'A URL generator for DJ by Design\'s custom website builder',
  image: __WEBPACK_IMPORTED_MODULE_15__assets_cookiecutter_jpg___default.a,
  link: 'https://thecookiecutter.herokuapp.com/',
  weight: 3,
  stack: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(toolkit.vue), [express])
}), new Project({
  title: 'Template Customizer - DJ by Design',
  description: 'A seemingly-static website that autofills with copy, based on URL query parameters.',
  image: __WEBPACK_IMPORTED_MODULE_16__assets_moderndj_jpg___default.a,
  link: 'http://bit.ly/2qihqtE',
  weight: 2,
  stack: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(toolkit.vue))
})];

/* harmony default export */ __webpack_exports__["a"] = projects;

/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(353)

var Component = __webpack_require__(47)(
  /* script */
  __webpack_require__(162),
  /* template */
  __webpack_require__(375),
  /* scopeId */
  "data-v-5d8c7ce8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(350)

var Component = __webpack_require__(47)(
  /* script */
  __webpack_require__(163),
  /* template */
  __webpack_require__(372),
  /* scopeId */
  "data-v-264e424e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 152:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Portfolio__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Portfolio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Portfolio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Modal__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Modal__);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home___default.a
  }, {
    path: '/portfolio',
    name: 'portfolio',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Portfolio___default.a,
    children: [{
      path: 'projects/:index/:name',
      name: 'portfolio.showcase',
      component: __WEBPACK_IMPORTED_MODULE_4__components_Modal___default.a
    }]
  }]
});

/***/ }),

/***/ 153:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = {
  state: {
    amplitude: -3,
    modalOpen: false,
    project: null
  },
  mutations: {
    setProject: function setProject(state, payload) {
      state.project = payload.data;
    }
  }
};

/***/ }),

/***/ 155:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(352)

var Component = __webpack_require__(47)(
  /* script */
  __webpack_require__(158),
  /* template */
  __webpack_require__(374),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 158:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_visibility__ = __webpack_require__(164);



/* harmony default export */ __webpack_exports__["default"] = {
  name: 'app',
  mounted: function mounted() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__components_visibility__["a" /* default */])();
  }
};

/***/ }),

/***/ 159:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweet_modal_vue_dist_sweet_modal_js__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweet_modal_vue_dist_sweet_modal_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sweet_modal_vue_dist_sweet_modal_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Project__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Project___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Project__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modal__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__projects__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Sine__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Sine___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Sine__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ismobilejs__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ismobilejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_ismobilejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_fuse_js__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_fuse_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_fuse_js__);












/* harmony default export */ __webpack_exports__["default"] = {
  name: 'hello',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App',
      scrollOrigin: 0,
      modalVisible: false,
      projectList: __WEBPACK_IMPORTED_MODULE_4__projects__["a" /* default */],
      query: []
    };
  },

  computed: {
    isMobile: function isMobile() {
      return __WEBPACK_IMPORTED_MODULE_6_ismobilejs___default.a.any;
    }
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_3__Modal___default.a
  },
  methods: {
    handleScroll: function handleScroll() {
      var winHeight = window.innerHeight;
      var centerScrollPos = window.scrollY - winHeight / 2;
      this.scrollOrigin = centerScrollPos;
    },
    showModal: function showModal() {
      this.modalVisible = true;
    }
  },
  mounted: function mounted() {
    console.log(__WEBPACK_IMPORTED_MODULE_4__projects__["a" /* default */]);
    var vm = this;
    var ecount = 0;
  },
  beforeDestroy: function beforeDestroy() {
    var a = 0;
  }
};

/***/ }),

/***/ 160:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  props: {
    visible: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  methods: {
    hide: function hide() {
      this.$emit('hide', true);
    }
  }
};

/***/ }),

/***/ 161:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweet_modal_vue_dist_sweet_modal_js__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweet_modal_vue_dist_sweet_modal_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweet_modal_vue_dist_sweet_modal_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Project__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Project___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Project__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modal__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__projects__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Sine__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Sine___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Sine__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ismobilejs__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ismobilejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_ismobilejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_fuse_js__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_fuse_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_fuse_js__);














/* harmony default export */ __webpack_exports__["default"] = {
  name: 'portfolio',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App',
      scrollOrigin: 0,
      modalVisible: false,
      projectList: __WEBPACK_IMPORTED_MODULE_6__projects__["a" /* default */],
      query: []
    };
  },

  computed: {
    routeProject: function routeProject() {
      var _this = this;

      var routeProj = this.projectList.find(function (project) {
        return project.title == _this.$route.params.name;
      });

      return routeProj || __WEBPACK_IMPORTED_MODULE_6__projects__["a" /* default */][0];
    },
    projects: function projects() {
      var options = {
        keys: ['stack']
      };
      var results = this.projectList;
      this.query.forEach(function (str) {
        var fuse = new __WEBPACK_IMPORTED_MODULE_9_fuse_js___default.a(results, options);
        results = fuse.search(str);
      });
      return results.sort(function (a, b) {
        return a.weight - b.weight;
      }, { weight: 0 });
    },
    isMobile: function isMobile() {
      return __WEBPACK_IMPORTED_MODULE_8_ismobilejs___default.a.any;
    },
    selectOptions: function selectOptions() {
      var fullStack = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a();
      this.projects.forEach(function (project) {
        project.stack.forEach(function (item) {
          fullStack.add(item);
        });
      });
      return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(fullStack));
    }
  },
  components: {
    Project: __WEBPACK_IMPORTED_MODULE_4__Project___default.a,
    Sine: __WEBPACK_IMPORTED_MODULE_7__Sine___default.a,
    Modal: __WEBPACK_IMPORTED_MODULE_5__Modal___default.a,
    Multiselect: __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default.a,
    SweetModal: __WEBPACK_IMPORTED_MODULE_2_sweet_modal_vue_dist_sweet_modal_js__["SweetModal"],
    SweetModalTab: __WEBPACK_IMPORTED_MODULE_2_sweet_modal_vue_dist_sweet_modal_js__["SweetModalTab"]
  },
  methods: {
    handleScroll: function handleScroll() {
      var winHeight = window.innerHeight;
      var centerScrollPos = window.scrollY - winHeight / 2;
      this.scrollOrigin = centerScrollPos;
    },
    showModal: function showModal() {
      this.modalVisible = true;
    },
    hideModal: function hideModal() {
      this.$router.push({ name: 'portfolio' });
    }
  },
  mounted: function mounted() {
    console.log(__WEBPACK_IMPORTED_MODULE_6__projects__["a" /* default */]);
    var vm = this;
    var ecount = 0;
  },
  beforeDestroy: function beforeDestroy() {
    var a = 0;
  }
};

/***/ }),

/***/ 162:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  props: {
    project: Object,
    index: Number
  },
  data: function data() {
    return {
      scrollY: 0
    };
  },

  computed: {
    styles: function styles() {
      return null;
      return {
        backgroundImage: "url('" + this.project.image + "')"
      };
    },
    scrollOrigin: function scrollOrigin() {
      var el = this.$refs.main;
      this.scrollY = el ? el.offsetTop : 0;
      return this.$parent.scrollOrigin;
    }
  }
};

/***/ }),

/***/ 163:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  props: {
    index: Number
  },
  data: function data() {
    return {
      scrollY: 0,
      modifier: -3
    };
  },
  mounted: function mounted() {
    var _this = this;

    var change = 0.03;
    var interval = setInterval(function () {
      if (Math.abs(_this.modifier) >= 5) change *= -1;
      _this.modifier += change;
    }, 200);
  },

  computed: {
    styles: function styles() {
      return {
        transform: this.transform
      };
    },
    transform: function transform() {
      var charge = this.index % 2 ? -1 : 1,
          wavelength = 10,
          amplitude = 3,
          scaleModifier = 5;
      var ratio = this.scrollY / 300;
      this.scrollOrigin;
      var offset = Math.sin(ratio * amplitude * this.modifier);
      var scale = offset;
      scale *= scaleModifier;
      return "translateX(" + offset + "px) scale(" + scale + ")";
    },
    borderRadius: function borderRadius() {
      var offset = Math.sin(this.scrollY - this.scrollOrigin / 30) * 5 * charge;
    },
    scrollOrigin: function scrollOrigin() {
      var el = this.$refs.main;
      this.scrollY = el ? el.offsetTop : 0;
      return this.$parent.scrollOrigin;
    },
    id: function id() {
      return "" + Math.round(Math.random() * 200000000);
    }
  }
};

/***/ }),

/***/ 164:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = function () {
  var hidden, state, visibilityChange;
  if (typeof document.hidden !== "undefined") {
    hidden = "hidden";
    visibilityChange = "visibilitychange";
    state = "visibilityState";
  } else if (typeof document.mozHidden !== "undefined") {
    hidden = "mozHidden";
    visibilityChange = "mozvisibilitychange";
    state = "mozVisibilityState";
  } else if (typeof document.msHidden !== "undefined") {
    hidden = "msHidden";
    visibilityChange = "msvisibilitychange";
    state = "msVisibilityState";
  } else if (typeof document.webkitHidden !== "undefined") {
    hidden = "webkitHidden";
    visibilityChange = "webkitvisibilitychange";
    state = "webkitVisibilityState";
  }

  var originalTitle = document.title;

  document.addEventListener(visibilityChange, function () {
    if (document[state].toLowerCase().includes('hidden')) {
      document.title = "Come back soon! :) ";
    } else {
      document.title = originalTitle;
    }
  }, false);
};

/***/ }),

/***/ 350:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 351:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 352:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 353:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 354:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 355:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 356:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bcw.967314f.jpg";

/***/ }),

/***/ 357:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cheatsheets.094a2e2.jpg";

/***/ }),

/***/ 358:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/chuckarnotes.8e049ab.png";

/***/ }),

/***/ 359:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cjmobiledj.afd60f5.jpg";

/***/ }),

/***/ 360:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cookiecutter.7d255d9.jpg";

/***/ }),

/***/ 361:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dronetracker.a4b97b8.jpg";

/***/ }),

/***/ 362:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ethos.a575c61.png";

/***/ }),

/***/ 363:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/flexbox.f8bde42.jpg";

/***/ }),

/***/ 364:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/inspire.dacdadf.jpg";

/***/ }),

/***/ 365:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/juicytag.8eb15bb.jpg";

/***/ }),

/***/ 366:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lastdrummer.450a8b4.jpg";

/***/ }),

/***/ 367:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/magenta-fm.369bf7b.jpg";

/***/ }),

/***/ 368:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/moderndj.fad739f.jpg";

/***/ }),

/***/ 369:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/shadowban.0e432e5.jpg";

/***/ }),

/***/ 370:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(351)

var Component = __webpack_require__(47)(
  /* script */
  __webpack_require__(159),
  /* template */
  __webpack_require__(373),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 371:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(354)

var Component = __webpack_require__(47)(
  /* script */
  __webpack_require__(161),
  /* template */
  __webpack_require__(376),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 372:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c"
  }, [_c('li', {
    ref: "main",
    style: (_vm.styles)
  })])
},staticRenderFns: []}

/***/ }),

/***/ 373:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row home"
  }, [_c('Modal', {
    attrs: {
      "visible": _vm.modalVisible
    },
    on: {
      "hide": function($event) {
        _vm.modalVisible = false
      }
    }
  }, [_c('div', {
    staticClass: "contact-card"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('p', {
    staticClass: "message"
  }, [_vm._v("Shoot me an email!")]), _c('input', {
    attrs: {
      "value": "mccallalexander96@gmail.com"
    }
  })]), _c('p', {
    staticClass: "message"
  }, [_vm._v("...or contact me here:")]), _c('div', {
    staticClass: "social-links"
  }, [_c('a', {
    attrs: {
      "href": "https://www.instagram.com/mccallalexander/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram fa-2x"
  })]), _c('a', {
    attrs: {
      "href": "https://github.com/mccallofthewild",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-github fa-2x"
  })]), _c('a', {
    attrs: {
      "href": "https://twitter.com/mccallthetall",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter fa-2x"
  })]), _c('a', {
    attrs: {
      "href": "https://www.linkedin.com/in/mccall-alexander-b245347b/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-linkedin fa-2x"
  })])])])]), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row header-row"
  }, [_c('div', {
    staticClass: "col-xs-12 header-col"
  }, [_c('header', [_c('h1', [_vm._v("McCall Alexander")]), _c('h2', [_vm._v("Web Development & Design")]), _c('address', [_vm._v("Boise, Idaho")]), _c('div', {
    staticClass: "cta-container"
  }, [_c('button', {
    staticClass: "btn-cta inline",
    on: {
      "click": _vm.showModal
    }
  }, [_c('div', {
    staticClass: "circle-mark"
  }), _vm._v("Contact me!")]), _c('span', {
    staticClass: "or-text inline"
  }, [_vm._v("...or check out my")]), _c('router-link', {
    staticClass: "btn-cta inline",
    attrs: {
      "tag": "button",
      "to": {
        name: 'portfolio'
      }
    }
  }, [_c('div', {
    staticClass: "circle-mark"
  }), _vm._v("Portfolio")])], 1), (false) ? _c('nav', [_vm._m(0)]) : _vm._e()])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://www.instagram.com/mccallalexander/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram fa-2x"
  })])]), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/mccallofthewild",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-github fa-2x"
  })])]), _c('li', [_c('a', {
    attrs: {
      "href": "https://twitter.com/mccallthetall",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter fa-2x"
  })])])])
}]}

/***/ }),

/***/ 374:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": "appear"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 375:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    ref: "main",
    staticClass: "project project__hoverclass",
    style: (_vm.styles),
    attrs: {
      "tag": "div",
      "to": {
        name: 'portfolio.showcase',
        params: {
          name: _vm.project.title,
          index: _vm.project.index
        },
        meta: {
          project: _vm.project
        }
      }
    }
  }, [_c('div', {
    staticClass: "text-area",
    attrs: {
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "words title"
  }, [_c('h3', {
    staticClass: "title-text"
  }, [_vm._v(_vm._s(_vm.project.title))])]), _c('div', {
    staticClass: "words description"
  }, [_c('p', {
    staticClass: "desc-text"
  }, [_vm._v(_vm._s(_vm.project.description))])])])])
},staticRenderFns: []}

/***/ }),

/***/ 376:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row portfolio-row"
  }, [_c('router-view', {
    attrs: {
      "visible": true
    },
    on: {
      "hide": _vm.hideModal
    }
  }, [_c('div', {
    staticClass: "project-modal"
  }, [_c('h2', {
    staticClass: "subject"
  }, [_c('b', [_vm._v("Subject: ")]), _vm._v(_vm._s(_vm.routeProject.title))]), _c('p', {
    staticClass: "desc"
  }, [_c('b', [_vm._v("Description: ")]), _vm._v(_vm._s(_vm.routeProject.description))]), _c('p', {
    staticClass: "link"
  }, [_c('b', [_vm._v("Link:")]), _c('a', {
    attrs: {
      "href": _vm.routeProject.link || 'javascript:void(0)',
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.routeProject.link || 'unavailiable'))])]), _c('div', {
    staticClass: "tech-area"
  }, [_c('h3', {
    staticClass: "tech-title"
  }, [_c('b', [_vm._v("Technologies Used:")])]), _c('ul', {
    staticClass: "tech-list"
  }, _vm._l((_vm.routeProject.stack), function(str) {
    return _c('li', [_vm._v(_vm._s(str))])
  }))]), _c('div', {
    staticClass: "image-area"
  }, [_c('h3', {
    staticClass: "image-title"
  }, [_vm._v("Image:")]), _c('img', {
    staticClass: "image",
    attrs: {
      "src": _vm.routeProject.image
    }
  })])])]), _c('div', {
    staticClass: "col-xs-12 nav-row"
  }, [_c('nav', [_c('router-link', {
    staticClass: "nav-brand",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("McCall Alexander")])], 1)]), _vm._m(0), _c('div', {
    staticClass: "col-xs-12 search-bg"
  }, [_c('multiselect', {
    key: "909090909",
    staticClass: "multiselect",
    attrs: {
      "options": _vm.selectOptions,
      "multiple": true,
      "close-on-select": true,
      "clear-on-select": true,
      "hide-selected": true,
      "placeholder": "Search something!☟",
      "show-labels": false
    },
    model: {
      value: (_vm.query),
      callback: function($$v) {
        _vm.query = $$v
      },
      expression: "query"
    }
  })], 1), _c('div', {
    staticClass: "col-xs-12 projects-bg"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "projects col-xs-10 col-xs-offset-1"
  }, [_c('transition-group', {
    staticClass: "projects-list",
    attrs: {
      "name": "fade",
      "appear": "appear"
    }
  }, _vm._l((_vm.projects), function(project, index) {
    return _c('div', {
      key: index,
      staticClass: "project-item"
    }, [_c('project', {
      key: index,
      attrs: {
        "index": index,
        "project": project
      }
    })], 1)
  }))], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 header-col"
  }, [_c('h1', [_vm._v("Portfolio")])])
}]}

/***/ }),

/***/ 377:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.visible) ? _c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-bg",
    on: {
      "click": _vm.hide
    }
  }), _c('div', {
    staticClass: "modal"
  }, [_c('button', {
    staticClass: "close",
    on: {
      "click": _vm.hide
    }
  }, [_c('span', {
    staticClass: "btn-close"
  }, [_vm._v("X")])]), _vm._t("default")], 2)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 381:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_es6__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_es6___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_es6__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_normalize_css_normalize_css__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_normalize_css_normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_normalize_css_normalize_css__);









__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */]);
var store = new __WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* Store */](__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: store,
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

/***/ })

},[381]);


// WEBPACK FOOTER //
// static/js/app.49d068fb9e5051e75076.js